import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
  name: "safeHTML",
})
export class SafeHTML implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string, newLineToBr: boolean = true): any {
    if (html && newLineToBr) {
      html = html.toString().replace(/(?:\r\n|\r|\n)/g, "<br>");
    }
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
